export enum ServiceName {
  ANOBIS_IMCOM = "imcom",
  ANOBIS = "Anobis",
  ANOBIS_INDIA_2 = "india2mis",
}

export enum ServiceHost {
  ANOBIS = "anobis.swiggy.com",
  ANOBIS_IMCOM = "im-com-app.swiggy.com",
  ANOBIS_INDIA_2 = "india-2-app.swiggy.com",
}

export const getServiceName = (): ServiceName => {
  const url = window.location.href;
  if (url.includes("/im-com-app") || url.includes("im-com-app.swiggy.com")) {
    // including `/im-com-app` in case we test on local
    return ServiceName.ANOBIS_IMCOM;
  }
  if (url.includes("/india-2-app") || url.includes("india-2-app.swiggy.com")) {
    // including `/india-2-app` in case we test on local
    return ServiceName.ANOBIS_INDIA_2;
  }
  return ServiceName.ANOBIS;
};

export const getXClientIdHeader = () => {
  return { "X-Client-Id": getServiceName() };
};
